"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Editable;
var _react = _interopRequireDefault(require("react"));
var _occasion = _interopRequireDefault(require("occasion"));
var _button = _interopRequireDefault(require("./button"));
var _inputOnBlur = _interopRequireDefault(require("./input-on-blur"));
var _input = _interopRequireDefault(require("./input"));
var _checkmark = _interopRequireDefault(require("./checkmark"));
var _validationContext = require("./validation-context");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function Editable(props) {
  const inputRef = _react.default.useRef(null);
  const [isEditing, setIsEditing] = _react.default.useState(false);
  const isValid = (0, _validationContext.useIsValid)();
  const onEdit = () => {
    if (isValid) {
      setIsEditing(true);
    }
  };
  const setInput = input => {
    // focus the input as soon as it is rendered
    if (input) input.focus();
    inputRef.current = input;
  };
  const onChange = (value, name) => {
    if (isValid) {
      props.onChange(value, name);
    }
  };
  const onBlur = () => {
    if (isValid) {
      setIsEditing(false);
    } else if (inputRef.current) {
      inputRef.current.focus();
    }
  };
  const renderEdit = () => {
    return /*#__PURE__*/_react.default.createElement(_inputOnBlur.default, {
      type: props.type,
      name: props.name,
      required: props.required,
      className: props.className,
      value: props.value,
      maxLength: props.maxLength,
      prefix: props.prefix,
      suffix: props.suffix,
      customValidation: props.customValidation,
      customValidationType: props.customValidationType,
      onChange: onChange,
      onBlur: onBlur,
      setInput: setInput
    });
  };
  const renderRead = () => {
    let value = props.value;
    const placeHolder = props.enabled && props.placeHolder ? props.placeHolder : '';
    switch (props.type) {
      case 'Date':
        const format = props.format || 'D MMM YYYY';
        value = value ? (0, _occasion.default)(value, format) : placeHolder;
        break;
      default:
        break;
    }
    return /*#__PURE__*/_react.default.createElement("span", {
      style: {
        backgroundColor: props.backgroundColor
      }
    }, props.prefix || '', props.children || value, props.suffix || '');
  };
  const enabled = props.enabled;

  // Not editable
  if (!enabled) {
    let className = 'read-only ';
    if (props.children && props.children.props) {
      className += props.children.props.className || '';
    }
    if (props.type === 'Checkbox') {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "form-check"
      }, /*#__PURE__*/_react.default.createElement(_checkmark.default, {
        checked: props.checked,
        className: className
      }), props.label ? ' ' + props.label : null);
    }
    return /*#__PURE__*/_react.default.createElement("span", {
      className: className
    }, renderRead());

    // editable checkbox always open to edit
  } else if (props.type === 'Checkbox') {
    const checkboxProps = Object.assign({}, props);
    delete checkboxProps.enabled;
    return /*#__PURE__*/_react.default.createElement(_input.default, checkboxProps);
    // Editable and has clicked to edit
    // or explicitly preparedForEdit so that always displayed as edit box
  } else if (isEditing || props.preparedForEdit) {
    return renderEdit();

    // Editable but in read mode - display clickable button
    // Use optimistic updates to prevent a flicker of the original value during updates
  } else {
    return /*#__PURE__*/_react.default.createElement("button", {
      className: "btn-block btn-editable",
      onFocus: onEdit,
      onClick: onEdit,
      type: "button",
      style: {
        minHeight: 23
      }
    }, renderRead());
  }
}